import {NgModule}             from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ProductHomeComponent } from "app/products/product-home/product-home.component";
import { ProductHomePageResolver } from "app/service/app.resolve";


const PRODUCTS_ROUTES: Routes = [
    { 
        path: ':parent-slug',
        component: ProductHomeComponent,
        resolve: { 
            productData: ProductHomePageResolver
        },
    },
    {
        path: "",
        redirectTo: '/',
        pathMatch: 'full'
    }
];


@NgModule({
    imports: [
        RouterModule.forChild(PRODUCTS_ROUTES)
    ],
    exports: [
        RouterModule
    ],
    providers:[
        ProductHomePageResolver
    ]
})
export class ProductsRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/products/productsrouting.module.ts